// src/OtpInput.js
import React, { useState, useEffect } from "react";
import "./../OnboardingCustomerInformation/OnboardingCustomerInformation.modules.css"; // Import CSS for styling
import { useTranslation } from "react-i18next";
import * as AppUrls from "../../../constants/AppUrls";
import { Redirect } from "react-router-dom";
import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";
import i18next from "i18next";
import { useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as Helpers from "../../../global/Helpers";
import * as utils from "../../../global/utils";
import * as Constants from "../../../constants/Constants";
import SessionExpiredPOPup from "../SessionExpiredPOPup/SessionExpiredPOPup";
import { groupIdSignal } from "../OnboardingHome/OnboardingHome";

const MinorEIDInfo = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const propsEIDinfo = location.state || null;

    const [formData, setFormData] = useState({
      firstNameEnglish: propsEIDinfo?.EIDData?.name || "",
      EMIRATES_ID: propsEIDinfo?.EIDData?.EMIRATES_ID || "",
      birthDate: propsEIDinfo?.EIDData?.birthDate || "",
      expiryDate: propsEIDinfo?.EIDData?.expiryDate || "",
      nationality: propsEIDinfo?.EIDData?.nationality || "",
      gender: propsEIDinfo?.EIDData?.Gender === "F" ? "Female" : propsEIDinfo.EIDData.Gender === "M" ? "Male" : "",
    });

  // const [formData, setFormData] = useState({
  //   firstNameEnglish: "",
  //   EMIRATES_ID: "",
  //   birthDate: "",
  //   expiryDate: "",
  //   nationality: "",
  //   gender: "",
  // });

  const [redirect, setRedirect] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    // setRedirect(AppUrls.MinorPassportScan);
    if (!validateSubmit()) return;
    var Items = [
      // { ID: "6", Value: propsEIDinfo?.EIDData?.Gender },
      // { ID: "49", Value: formData.firstNameEnglish },

      {
        ID: "303",
        Value: groupIdSignal
          ? groupIdSignal.value === "Minor"
            ? "Y"
            : "N"
          : "N",
      },
     { ID: "57", Value: formData.firstNameEnglish },
     { ID: "59", Value: formData.EMIRATES_ID },
     { ID: "406", Value: formData.birthDate },
     { ID: "244", Value: formData.expiryDate },
     { ID: "408", Value: formData.nationality },
     { ID: "407", Value: propsEIDinfo?.EIDData?.Gender },
      { ID: "258", Value: "1" },
    ];
    saveKycData(Items, "");
  };
  const validateSubmit = () => {
    ;
    if (formData.firstNameEnglish === "") {
      Helpers.errorNotify(t("Full name is required"), i18next.language);
      return false;
    }

    if (formData.EMIRATES_ID === "") {
      Helpers.errorNotify(t("Emirates ID is required"), i18next.language);

      return false;
    }

    if (formData.EMIRATES_ID.length > 15 || formData.EMIRATES_ID.length < 15) {
      Helpers.errorNotify(t("Emirates ID must be exactly 15 digits."));

      return false;
    }

    if (formData.birthDate === "") {
      Helpers.errorNotify(t("Birth Date is required"), i18next.language);
      return false;
    }
    if (formData.nationality === "") {
      Helpers.errorNotify(t("Nationality is required"), i18next.language);
      return false;
    }
    if (formData.gender === "") {
      Helpers.errorNotify(t("Gender is required"), i18next.language);
      return false;
    }
    return true;
  };

  const saveKycData = async (Items, RedirectPath) => {
    try {
      if (!validateSubmit(Items[0].Value)) return;

      const body = {
        RequestItems: Items,
        reqID: localStorage.getItem("RID"),
      };
      var response = utils.CallKYCAPI(Constants.GetKYCCibc, body);
      await response
        .then((response) => {
          ;
          if (response.data.Error_code === "0") {
            setRedirect(AppUrls.MinorPassportScan);
          } else if (response.data.Error_code === "-1") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            Helpers.errorNotify(response.data.Error_Msg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("saveKycData", error);
        });
    } catch (error) {
      console.error("Error posting data saveKycData:", error);
    }
  };

  const handleChange = (e) => {
    ;
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboardingPersonal);
  };

  if (redirect !== null) {
    return (
      <Redirect
        to={{
          pathname: redirect,
          state: {},
        }}
      />
    );
    // return <Redirect to={redirect} />;
  }

  return (
    <>
      <NavbarOnboarding />

      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">{t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} />
        </div>
        <div className="CustomerInfo-container">
          <div className="CustomerInfo-form">
            <h2 style={{ marginBottom: "2rem" }}>
              {" "}
              {t("CustomerInformation")}
            </h2>

            {/* English Names */}
            <div className="form-group">
              <label>{t("full_name")}</label>
              <input
                type="text"
                name="firstNameEnglish"
                value={formData.firstNameEnglish}
                onChange={handleChange}
                disabled
              />
              {/* {errors.firstNameEnglish && <span className="error">{errors.firstNameEnglish}</span>} */}
            </div>

            <div className="form-group">
              <label>{t("EMIRATES_ID")}</label>
              <input
                type="text"
                name="EMIRATES_ID"
                value={formData.EMIRATES_ID}
                onChange={handleChange}
                disabled
              />
              {/* {errors.firstNameEnglish && <span className="error">{errors.firstNameEnglish}</span>} */}
            </div>

            {/* Birth Date */}
            <div className="form-group">
              <label>{t("field_date_of_birth")}</label>
              <input
                type="text"
                name="birthDate"
                value={formData.birthDate}
                onChange={handleChange}
                disabled
              />

              {/* <input type="date" name="birthDate" value={formData.birthDate} onChange={handleChange} dateFormat="dd/MM/yyyy" disabled /> */}
              {/* {errors.birthDate && <span className="error">{errors.birthDate}</span>} */}
            </div>
            {/* expiry Date */}
            <div className="form-group">
              <label>{t("ExpiryDate")}</label>
              <input
                type="text"
                name="expiryDate"
                value={formData.expiryDate}
                onChange={handleChange}
                disabled
              />

              {/* <input type="date" name="expiryDate" value={formData.expiryDate} onChange={handleChange} dateFormat="dd/MM/yyyy" disabled /> */}
              {/* {errors.birthDate && <span className="error">{errors.birthDate}</span>} */}
            </div>

            {/* nationality*/}
            <div className="form-group">
              <label>{t("field_nationality")}</label>
              <input
                type="text"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
                disabled
              />
              {/* {errors.firstNameEnglish && <span className="error">{errors.firstNameEnglish}</span>} */}
            </div>

            {/* Gender*/}
            <div className="form-group">
              <label>{t("field_gender")}</label>
              <input
                type="text"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                disabled
              />
              {/* {errors.firstNameEnglish && <span className="error">{errors.firstNameEnglish}</span>} */}
            </div>

            <button
              type="submit"
              className="submit-button mb-2"
              onClick={handleSubmit}
            >
              {t("Confirm")}
            </button>

            {/* <div>
            
              <button className="backBtn" onClick={handleBack}>
                {t("back")}
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default MinorEIDInfo;
